import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

// Shadcn components
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2 } from "lucide-react";
import Footer from '@/components/common/Footer';

// Types

// Services
import { getWaiverDetails } from '@/services/ticket/getWaiverDetails';
import { getTenantIdFromStorage } from '@/services/authentication/supertokens';

const CheckoutSuccess = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const session_id = searchParams.get('session_id');
    const orgId = getTenantIdFromStorage();

    if (!session_id) {
        return <div>Loading...</div>;
    }

    return (
        <div className="relative min-h-screen bg-gradient-to-br from-blue-50 via-white to-teal-50 overflow-x-hidden">
            <div className="container mx-auto px-4 md:px-8 lg:px-12 pt-12 md:pt-32 pb-8 relative z-10">
                <div className="max-w-2xl mx-auto">
                    <Card className="w-full shadow-xl border-0 bg-white/90 backdrop-blur-md">
                        <CardHeader className="text-center pb-0">
                            <div className="flex justify-center mb-4">
                                <div className="rounded-full bg-green-100 p-3">
                                    <CheckCircle2 className="h-12 w-12 text-green-600" />
                                </div>
                            </div>
                            <CardTitle className="text-3xl font-bold text-blue-900">Checkout Complete!</CardTitle>
                            <CardDescription className="text-lg text-gray-600 mt-2">
                                Your ticket has been successfully purchased.
                            </CardDescription>
                        </CardHeader>
                        <CardContent className="pt-6">
                            <div className="flex flex-col items-center gap-4">
                                <Badge variant="secondary" className="bg-blue-100 text-blue-700 border-0 break-all text-center px-4 py-2">
                                    Session ID: {session_id}
                                </Badge>
                                <p className="text-sm text-gray-500 text-center">
                                    You will receive your ticket and receipt via email soon.
                                </p>
                                
<p className="text-sm text-gray-500 text-center">
                                    If you have any questions about your purchase, please contact the event organizer.
                                </p>
                            </div>
                        </CardContent>
                        <CardFooter className="flex flex-col items-center w-full pt-0">
                            <Separator className="my-4 w-full" />
                            <div className="flex flex-col items-center gap-4 w-full">
                                <div className="flex flex-col items-center mt-4 text-xs text-gray-400 w-full">
                                    <img src="/branding/TriEvents_Logo.png" alt="TriEvents" className="h-6 mb-1" />
                                    <span>Secure checkout powered by Stripe</span>
                                </div>
                            </div>
                        </CardFooter>
                    </Card>

                    {/* Platform Support Section */}
                    <div className="mt-12 flex flex-col items-center gap-6 text-center text-gray-500">
                        <div className="flex items-center gap-3">
                            <div className="h-px w-24 bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                            <span className="text-base font-medium">Platform Support</span>
                            <div className="h-px w-24 bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                        </div>
                        <div className="flex flex-col items-center gap-3 text-sm">
                            <p className="text-gray-600">Having trouble with our platform?</p>
                            <p className="text-gray-500">Contact Tricode Cloud Support</p>
                            <a href="mailto:support@tricode.cloud" className="text-blue-600 hover:text-teal-600 transition-colors">
                                support@tricode.cloud
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-16 md:mt-24">
                <Footer />
            </div>
        </div>
    );
};

export default CheckoutSuccess;